import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackAuctionAddModalShow = () => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory, // 'New_ad' | 'Edit_ad'
    action: 'auction_popup',
    label: 'premium_show',
  });
};

export const trackAuctionAddModalClose = (type, bet) => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory, // 'New_ad' | 'Edit_ad'
    action: 'auction_popup',
    label: `premium_${type}/${bet}`,
  });
};
